import React, { useRef, useState } from "react";
// import "./style.css";
import {
  Box,
  Button,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import VisibilityIcon from "@mui/icons-material/Visibility";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import DownloadIcon from "@mui/icons-material/Download";
import { useNavigate } from "react-router-dom";
import { PDFExport } from "@progress/kendo-react-pdf";
import { useSelector } from "react-redux";
import { doc, getDoc, addDoc, collection, updateDoc } from "firebase/firestore";
import { db } from "../../firebase.config";
import Nav from "../../component/nav/nav";
import PVATestReport from "../component/report_sub_comp/pvaTestReport";
import PVCReport from "../component/report_sub_comp/pvcReport";
import PVIReport from "../component/report_sub_comp/pviReport";
import PVHOverDoc from "../component/report_sub_comp/pvhOverDoc";

export default function Preview() {
  const navigate = useNavigate();
  const { formData, referenceNo, selectedInspectorId } = useSelector(
    (state) => state.ins_info
  );

  const { invertersList, selectedPanel } = useSelector(
    (state) => state.pva_test
  );
  const pvInstallation = useSelector((state) => state.pvi_list);
  const arrayFrameEarthing = useSelector((state) => state.afe_list);
  const checklistData = useSelector((state) => state.pvc_list);

  const handleProjectSave = async () => {
    try {
      const authId = localStorage.getItem("authId");
      const existingProjectId = localStorage.getItem("ProjectID");

      const projectData = {
        authId,
        referenceNo,
        formData,
        selectedInspectorId,
        selectedPanel,
        invertersList,
        arrayFrameEarthing,
        pvInstallation,
        checklistData,
        updatedAt: new Date(),
      };

      let isNewProject = false;

      if (existingProjectId) {
        const existingRef = doc(db, "projects", existingProjectId);
        const existingSnap = await getDoc(existingRef);

        if (existingSnap.exists()) {
          await updateDoc(existingRef, projectData);
        } else {
          await addDoc(collection(db, "projects"), {
            ...projectData,
            createdAt: new Date(),
          });
          isNewProject = true;
        }
      } else {
        await addDoc(collection(db, "projects"), {
          ...projectData,
          createdAt: new Date(),
        });
        isNewProject = true;
      }
      if (isNewProject) {
        localStorage.setItem("lastRef", referenceNo);
        localStorage.removeItem("ProjectID");

        if (authId) {
          const userRef = doc(db, "users", authId);
          await updateDoc(userRef, {
            lastRef: referenceNo,
            lastUpdated: new Date(),
          });
        }
      }

      return navigate("/dashboard");
    } catch (error) {
      console.error("❌  Error saving project:", error);
      return false;
    }
  };

  // Example data (replace later with actual report list)
  const [reportList] = useState([
    {
      id: 1,
      name: "Solar PV Installation Checklist",
      downloadName: `${referenceNo}-F44 ${formData.manualRef}`,
    },
    {
      id: 2,
      name: "Solar PV Commision Checklist",
      downloadName: `${referenceNo}-F44A ${formData.manualRef}`,
    },
    {
      id: 3,
      name: "Solar Pv Array Test Report",
      downloadName: `${referenceNo}-F43 ${formData.manualRef}- Solar PV Array Test Form - ${formData.installationAddress}`,
    },
    {
      id: 4,
      name: "PV Handover Document",
      downloadName: `${referenceNo}-F43A ${formData.manualRef}`,
    },
  ]);

  // Dialog control
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedReport, setSelectedReport] = useState(null);

  // 🧭 Open "create new" project
  const createNewProject = () => {
    navigate("/createProject");
  };

  // 👁️ Preview report dialog
  const handlePreview = (report) => {
    setSelectedReport(report);
    setOpenDialog(true);
  };

  const handleClose = () => {
    setOpenDialog(false);
    setSelectedReport(null);
  };

  const pdfExportComponent = useRef(null);

  const handleExport = () => {
    if (pdfExportComponent.current) {
      pdfExportComponent.current.save();
    }
  };

  const columns = [
    {
      field: "name",
      headerName: "Report Name",
      flex: 1,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <span style={{ color: "#27326A", fontWeight: 500 }}>
          {params.value}
        </span>
      ),
    },
    {
      field: "preview",
      headerName: "Project Preview",
      flex: 1,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <Tooltip title="View Project Preview">
          <Button
            variant="outlined"
            size="small"
            sx={{
              borderColor: "#27326A",
              color: "#27326A",
              textTransform: "none",
              fontWeight: 500,
              "&:hover": {
                backgroundColor: "#27326A",
                color: "white",
              },
            }}
            startIcon={<VisibilityIcon />}
            onClick={() => handlePreview(params.row)}
          >
            Preview
          </Button>
        </Tooltip>
      ),
    },
  ];

  const dashboard = () => {
    navigate("/dashboard");
  };

  const renderSelectedReport = () => {
    switch (selectedReport?.name) {
      case "Solar PV Installation Checklist":
        return <PVIReport />;
      case "Solar PV Commision Checklist":
        return <PVCReport />;
      case "Solar Pv Array Test Report":
        return <PVATestReport />;
      case "PV Handover Document":
        return <PVHOverDoc />;
      default:
        return <div>No report selected</div>;
    }
  };

  return (
    <Box sx={{ height: "100vh", display: "flex", flexDirection: "column" }}>
      {/* === Top Nav === */}
      <Box
        sx={{
          width: "100%",
        }}
      >
        <Nav />
      </Box>

      <Box>
        <Typography variant="h6" gutterBottom fontWeight="bold">
          Reports Preview
        </Typography>
      </Box>

      {/* === Header & Button === */}
      <Box
        sx={{
          width: "100%",
          backgroundColor: "#fff",
          borderBottom: 1,
          borderColor: "divider",
          padding: "10px",
          display: "flex",
          justifyContent: "space-around",
          alignItems: "center",
        }}
      >
        <Button
          variant="contained"
          size="small"
          sx={{
            backgroundColor: "#27326A",
            width: "160px",
            height: "40px",
            textTransform: "none",
            fontWeight: 500,
            "&:hover": { backgroundColor: "#1F2955" },
          }}
          onClick={dashboard}
        >
          Go to Dashboard
        </Button>
        <Button
          variant="contained"
          size="small"
          sx={{
            backgroundColor: "#27326A",
            width: "160px",
            height: "40px",
            textTransform: "none",
            fontWeight: 500,
            "&:hover": { backgroundColor: "#1F2955" },
          }}
          onClick={createNewProject}
        >
          <AddCircleOutlineIcon sx={{ mr: 1, width: 18, height: 18 }} />
          Edit Project
        </Button>
      </Box>

      {/* === DataGrid Table === */}
      <Box sx={{ width: "100%", maxWidth: "550px", margin: "0 auto" }}>
        <DataGrid
          sx={{
            borderRadius: 3,
            border: 0,
            width: "100%",
            "& .MuiDataGrid-columnHeaderTitle": {
              fontWeight: "bold",
              color: "#27326A",
            },
            "& .MuiDataGrid-cell": { outline: "none" },
            "& .MuiDataGrid-row:nth-of-type(even)": {
              backgroundColor: "#F9FAFB",
            },
          }}
          disableColumnMenu
          disableSelectionOnClick
          hideFooter
          getRowId={(row) => row.id}
          columns={columns}
          rows={reportList}
        />

        <Button
          variant="contained"
          size="small"
          sx={{
            margin: "1rem auto",
            backgroundColor: "#27326A",
            width: "100%",
            height: "40px",
            textTransform: "none",
            fontWeight: 500,
            "&:hover": { backgroundColor: "#1F2955" },
          }}
          onClick={() => handleProjectSave()}
        >
          Save Project
        </Button>
      </Box>

      {/* === Preview Dialog === */}
      <Dialog
        open={openDialog}
        className="modalReport"
        onClose={handleClose}
        fullWidth
        PaperProps={{ sx: { borderRadius: 3, p: 2 } }}
      >
        <DialogTitle
          sx={{
            fontWeight: 600,
            color: "#27326A",
            mb: 1,
          }}
        >
          {selectedReport ? selectedReport.name : "Report Preview"}
        </DialogTitle>

        <DialogContent>
          {/* <div style={{ position: "absolute", left: "-9999px", top: 0 }}> */}
            <PDFExport
              ref={pdfExportComponent}
              paperSize="A4"
              margin={{
                top: "12px",
                bottom: "10px",
                left: "12px",
                right: "12px",
              }}
              fileName={`${
                selectedReport?.downloadName || "Inspection_Report"
              }.pdf`}
            >
              {renderSelectedReport()}
            </PDFExport>
          {/* </div> */}
          {/* <div>
            {renderSelectedReport()}
          </div> */}
        </DialogContent>

        <DialogActions sx={{ justifyContent: "space-between" }}>
          <Button
            onClick={handleClose}
            variant="outlined"
            sx={{ color: "#27326A", borderColor: "#27326A" }}
          >
            Close
          </Button>
          <Button
            onClick={handleExport}
            variant="contained"
            sx={{ backgroundColor: "#27326A", textTransform: "none" }}
            startIcon={<DownloadIcon />}
          >
            Download Report
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
